module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921061149_T.bbfbb2cf.jpg";